// Editable content — templates library. Draft wording; owner will replace.
// Merge fields: {client_name} {event_name} {event_date} {reaching_time} {ready_by_time}
// {venue} {total} {advance} {balance} {guest_count} {artist_name} {artist_fee}

export const TEMPLATES = [
  {
    key: 'payment_confirmation_nonbridal',
    label: 'Payment / Slot Confirmation — Non-Bridal',
    audience: 'client',
    finalised: false,
    body:
`Hi {client_name},

Your slot for {event_date} is confirmed. Advance of {advance} received — thank you.

Reaching time: {reaching_time}
Ready by: {ready_by_time}
Venue: {venue}

Balance of {balance} is payable on the day, before we begin.

Warmly,
Rishika`
  },
  {
    key: 'detail_form_after_advance',
    label: 'Detail Form After Advance — Non-Bridal',
    audience: 'client',
    finalised: false,
    body:
`Hi {client_name},

Advance received — your date is locked. Please fill this short detail form so I can prep for your look:

[form link]

Send it back at your convenience. Any questions, message me anytime.

Rishika`
  },
  {
    key: 'bridal_detail_form_prepayment',
    label: 'Bridal Detail Form — Pre-Payment',
    audience: 'client',
    finalised: false,
    body:
`Hi {client_name},

Delighted you're considering me for your wedding.

Before we lock the date, I'd love a little more detail — my bridal consultation form takes about 10 minutes:

[form link]

Once I have this I can share a tailored quotation and we can chat over a video or in-person consultation.

Warmly,
Rishika`
  },
  {
    key: 'bridal_booking_confirmation',
    label: 'Bridal Booking Confirmation',
    audience: 'client',
    finalised: false,
    body:
`Hi {client_name},

Your bridal dates are confirmed. Truly looking forward to being part of your celebration.

What's included:
• A video or in-person consultation ahead of the wedding
• Personal bridal assistance with styling, lehenga and jewellery
• Trial and prep guidance

I'll share the pre-appointment prep guide closer to your dates.

Warmly,
Rishika`
  },
  {
    key: 'bridal_prep_guide',
    label: 'Bridal Pre-Appointment Prep Guide',
    audience: 'client',
    finalised: false,
    body:
`Hi {client_name},

A short prep list for your bridal makeup:

Skin
• Hydrate well the week before — water and a rich moisturiser at night
• No new products or facials in the 7 days before
• Lip scrub and balm the night before

Hair
• Wash the night before, not the morning of
• Avoid heavy oils on the day

Day-of emergency bag
• Blotting sheets, translucent powder, lip colour, safety pins, bindis, hair pins, mints, water, phone charger

See you on {event_date}. I'll reach {venue} by {reaching_time}.

Warmly,
Rishika`
  },
  {
    key: 'birthday_wish',
    label: 'Stay-in-Touch — Birthday',
    audience: 'client',
    finalised: false,
    body:
`Happy birthday, {client_name}. Wishing you a beautiful year — always lovely to hear from you.

Rishika`
  },
  {
    key: 'anniversary_wish',
    label: 'Stay-in-Touch — Anniversary',
    audience: 'client',
    finalised: false,
    body:
`Happy anniversary, {client_name}. Hope the day is as lovely as your wedding was.

Rishika`
  },
  {
    key: 'day_before_reminder',
    label: 'Day-Before Reminder',
    audience: 'client',
    finalised: false,
    body:
`Hi {client_name},

Just a quick note ahead of tomorrow. I'll reach {venue} by {reaching_time}, ready by {ready_by_time}.

Please have a clean face and hair washed the night before. Balance of {balance} is payable before we begin.

See you tomorrow.

Rishika`
  },
  {
    key: 'balance_reminder',
    label: 'Balance Payment Reminder',
    audience: 'client',
    finalised: false,
    body:
`Hi {client_name},

A gentle reminder — the balance of {balance} is due before {event_date}. UPI or bank transfer both fine.

Message me once done and I'll send you a receipt.

Rishika`
  },
  {
    key: 'post_event_thank_you',
    label: 'Post-Event Thank You + Review',
    audience: 'client',
    finalised: false,
    body:
`Hi {client_name},

Thank you for having me be part of {event_name}. You looked wonderful.

If you have a moment, I'd be grateful for a Google review or an Instagram tag. It genuinely helps.

Warmly,
Rishika`
  },
  {
    key: 'photo_request_to_photographer',
    label: 'Photo Request — Client\'s Photographer',
    audience: 'vendor',
    finalised: false,
    body:
`Hi, I did {client_name}'s makeup for her {event_name} on {event_date}. Would love to see a few edited images when they're ready — happy to credit and tag you across my socials.

Rishika Sharma`
  },
  {
    key: 'hired_artist_confirmation',
    label: 'Hired Artist Booking — Internal',
    audience: 'internal',
    finalised: false,
    body:
`Hi {artist_name},

Confirming your booking with Team Rishika:

Event: {event_name}
Date: {event_date}
Reporting time: {reaching_time}
Venue: {venue}
Agreed fee: {artist_fee}

Please confirm receipt. Payout will follow within our usual window post-event.

Team Rishika`
  },
  {
    key: 'cold_photographer',
    label: 'Cold Email — Photographers / Studios',
    audience: 'b2b',
    finalised: false,
    body:
`Hi,

I'm Rishika Sharma — a Gurugram-based bridal and party makeup artist, certified through Parul Garg and Meera Sakhrani, working weddings across NCR and destinations.

I'd love to explore a collaboration — happy to swap referrals, plan a styled shoot, or simply meet for coffee if you're open.

Portfolio: www.rishikasharma.com
Instagram: @rishikasharma.mua

Warm regards,
Rishika`
  },
  {
    key: 'cold_planner',
    label: 'Cold Email — Wedding Planners / Decorators',
    audience: 'b2b',
    finalised: false,
    body:
`Hi,

I'm Rishika Sharma — a professional bridal makeup artist based in Gurugram, with certifications through Parul Garg and Meera Sakhrani. I work weddings across NCR and destination.

If you have brides looking for a discreet, editorial approach to bridal beauty, I'd be delighted to be on your recommendation list.

Portfolio: www.rishikasharma.com

Warm regards,
Rishika`
  },
  {
    key: 'followup_day4',
    label: 'B2B Follow-up — Day 4',
    audience: 'b2b',
    finalised: false,
    body:
`Hi,

Following up on my note from earlier this week — happy to share references or set up a short call if useful.

Warm regards,
Rishika`
  },
  {
    key: 'followup_day10',
    label: 'B2B Follow-up — Day 10',
    audience: 'b2b',
    finalised: false,
    body:
`Hi,

One last check-in — I'll leave this here for now, but if you'd like to reconnect at any point, I'm one message away.

Warm regards,
Rishika`
  },
];

export const EVENT_TYPES = ['Mehendi', 'Haldi', 'Sangeet', 'Wedding', 'Reception', 'Trial', 'Party', 'Photoshoot'];

export const PRICE_LIST = [
  { name: 'Basic party makeup', rate: 3500 },
  { name: 'High-end party makeup', rate: 4500 },
  { name: 'Guest / family makeup (per person)', rate: 3500 },
  { name: 'Bridal engagement / reception', rate: 0 },
  { name: 'Bridal wedding day', rate: 0 },
  { name: 'Trial', rate: 0 },
  { name: 'Hair styling only', rate: 0 },
  { name: 'Saree / lehenga draping only', rate: 0 },
];

export const DEFAULT_INCLUDES = [
  'Premium, professional-grade products',
  'Skin preparation before application',
  'Hair styling of choice',
  'Saree or lehenga draping',
  'False lashes',
  'Touch-up before departure',
];
